import React, { Component } from 'react';
import { connect } from 'react-redux';
import {Row, cls } from '../../../packages/components';
import Chunker from './Chunker';
import CardEpisode from './CardEpisode';

class EpisodesList extends Component {
    constructor(props = {}) {
        super(props);
        this.state = {
            episodeNumber: 0,
            episodes: [],
            pbi: props.pbi || [],
            dataAfterBack: props.dataAfterBack
        };
        this.chunker = null;
        // numero de items por columna
        this.quantity = 6;
        this.rightDirection =  'ArrowRight';
        this.leftDirection =  'ArrowLeft';
        this.lastElement = null;
        this.firstElement = null;
        this.previousCard =  null;
        this.nextCard = null;
    }

    componentDidMount = () => {
        this.addListener();

    };

    getWidth() {
        const width = 100 / (this.quantity - 1) + 4;
        return `${width}%`;
    }

    componentWillReceiveProps(nextProps) {
        this.setState({ pbi: nextProps.pbi });
        const {episodes = []} = nextProps;
        if(!nextProps.isBookmarkUpdateOrPBIUpdate) {
            this.chunker = null;
            this.chunker = new Chunker(episodes, this.quantity);
        }

        if(this.state.dataAfterBack) {
            let index = nextProps.dataAfterBack.number - nextProps.dataAfterBack.position;
            if(index < 0) {
                index = episodes.length + index;
            }
            this.chunker.setIndex(index);
            this.setState({dataAfterBack: null});
        }
        const episodesList = this.chunker.current() || [];
        this.setData(episodesList);
    }

    setData(episodesList, target = null, e){
        if (episodesList && episodesList.items && Array.isArray(episodesList.items)) {
            this.setState({episodes: episodesList.items }, () => {
                this.lastElement = episodesList.items[this.quantity-1] || null;
                this.firstElement = episodesList.items[0] || null;

                if(e) {
                  window.SpatialNavigation.focus(`#modal_episode_number_${target}`);
                }
            });
        }
    }

    addListener = () => {
        const x = Array.from(
            document.getElementsByClassName('aaf-main-modal-options-episodes-main')
        );
        if (x && Array.isArray(x) && x[0]) {
            const element = x[0];
            element && typeof element.addEventListener === 'function' && element.addEventListener('keydown', this.hasFocused);
        }
    };

    hasFocused = (e) => {
        // Se resetea el scrollLeft del container para que no se mueva al hacer foco.
        // El corrimiento del container solo sucedía en Cajas (Kaon, Huawei, etc...)
        const { target = null, key = null } = e;
        if(target) target.parentNode.parentNode.scrollLeft = 0;
        if (
            e &&
            key &&
            (key === this.rightDirection || key === this.leftDirection)
        ) {
            const targetId = e && target && typeof target.getAttribute == 'function' &&  target.getAttribute('data-id') || null;
            switch(key){
                case this.rightDirection:
                    this.getRightElements(targetId, e);
                    break;
                case this.leftDirection:
                    this.getLeftElements(targetId, e);
                    break;
                default:
            }
        }
    };

    getLeftElements = (target, e) =>{
      const totalItemsSession = this.props.episodes.length - 1
      const targetIdNumber = parseInt(target) - 1;
      const targetId = parseInt(target) === 0 ? totalItemsSession : targetIdNumber;
      if(target && typeof this.firstElement === 'object' && this.firstElement.hasOwnProperty('idx_temp')){
            if(targetId === this.firstElement.idx_temp){
                this.chunker.setIndex(targetId - 1);
                const episodesList = this.chunker.current() || [];
                this.setData(episodesList, targetId, e)
            }
        }
    }


    getRightElements = (target, e) =>{
        const totalItemsSession = this.props.episodes.length - 1;
        const targetIdNumber = parseInt(target) + 1;
        const targetId = totalItemsSession === parseInt(target) ? 0 : targetIdNumber;
        if(target && this.lastElement && typeof this.lastElement === 'object' && this.lastElement.hasOwnProperty('idx_temp')){
            if(targetId === this.lastElement.idx_temp){
                if(typeof this.firstElement === 'object' && this.firstElement.hasOwnProperty('idx_temp')){
                    const id = parseInt(this.firstElement.idx_temp) || 0;
                    if(this.chunker && typeof this.chunker.setIndex === 'function'){
                        this.chunker.setIndex(id + 1);
                        const episodesList = this.chunker.current() || [];
                        this.setData(episodesList, targetId, e)
                    }
                }
            }
        }
    }

    render() {
        const {episodes = [], pbi = [] } = this.state;
        const { bookmark = [] } = this.props;
        return (
            <Row className={cls(`aaf-main-modal-options-episodes-main`)}>
                {episodes &&
                    Array.isArray(episodes) &&
                    episodes.map((episode, index) => {
                        let percent = null;
                        let bookMarkByEpisode = null;

                        if(bookmark && Array.isArray(bookmark)){
                            bookMarkByEpisode = bookmark.find( book => book.id === episode.id);
                        }
                        if(bookMarkByEpisode){
                            const {vistime: {last : {progress = null} = {}} = {}} =  bookMarkByEpisode;
                            percent = progress;
                        }
                        return (
                            <CardEpisode
                                totalEpisodes ={this.props.episodes.length}
                                episode={episode}
                                width={this.getWidth()}
                                percent ={percent}
                                pbi={pbi[episode && episode.id]}
                                onClick={this.props.onClick || null}
                                key={episode.key}
                                ribbonLength={episodes.length}
                                indexCount={index}
                            />
                        );
                    })
                }
                {
                    this.nextCard && <CardEpisode episode={this.nextCard} width={`${5}%`} pbi={pbi[episode.id]} isFakeCard={true}/>
                }
            </Row>
        );
    }
}

const mapStateToProps = state => ({
    // user: state.user
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(EpisodesList);



// WEBPACK FOOTER //
// ./src/components/EpisodeSelection/components/EpisodesList.jsx